import {
  getABTestConfig,
  glowMinderABTestRouteConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

/**
 * GlowMinder onboarding outlet
 * Uses shared ABTestSectionOutlet with app-specific configuration
 */
export default function GlowMinderOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={glowMinderABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      variantPathPrefixes={{ v1: 'v1' }}
      validVariants={['baseline', 'v1']}
    />
  )
}
